var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-button',{staticClass:"button is-primary",attrs:{"loading":_vm.loading},on:{"click":function($event){return _vm.$emit('click')}}},[_vm._t("default",function(){return [_vm._v(_vm._s(_vm._f("capitalize")(String(_vm.$t("general.save")))))]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }